import type { IconData } from '@stacksjs/iconify-core'

export const caretRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M148.092 496h-36.45V16.333h34.547L416 256.286Zm-4.45-439.108v400.15l224.287-200.684Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default caretRight
